module.exports = __webpack_public_path__ + "static/media/iconStudents.9a05e62b.svg";